import {ViewBase} from "../../../../../packages/RawDogJS/src/core/viewBase";
import {IView} from "../../../../../packages/RawDogJS/src/interfaces/IView";
import {IPresenter} from "../../../../../packages/RawDogJS/src/interfaces/IPresenter";
import {Router} from "../../../../../packages/RawDogJS/src/router";
import {ParcelDependencyContainer} from "../../../../../packages/RawDogJS/src/core/ParcelDependencyContainer";

export class HelloWorldView extends ViewBase implements  IView{
    
    _presenter: IPresenter;
    private _view: HelloWorldView;

    constructor(viewName:string, router: Router, dependencyContainer: ParcelDependencyContainer) {
        super(viewName, router, dependencyContainer);
        
        
    }

    render(): void {
    }

    setPresenter(presenter: IPresenter) {
        this._presenter = presenter;
    }
    
    
    
    get fullName(){
        return this.getValueById('fullName');
    }
    
    set fullName(name){
        this.setTextById('fullName', name);
    }
    
    set message(message:string){
        this.setTextById('message', message);
    }
    
}